export enum EmotePolicy {
    USER_CAN_REACT = 'USER_CAN_REACT',
    NOBODY_CAN_REACT = 'NOBODY_CAN_REACT',
}
